import React, { useState, useEffect, useContext } from 'react';
import { Sidebar, Menu, MenuItem, SubMenu } from 'react-pro-sidebar';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  IoSettingsOutline, IoLogOutOutline, IoChevronForwardOutline, IoDocumentTextOutline
} from 'react-icons/io5';
import { BsTruck } from 'react-icons/bs';
import { FiPackage, FiEdit, FiTruck, FiLock, FiX, FiFileText, FiCreditCard, FiUser } from 'react-icons/fi';
import { FaBuilding } from 'react-icons/fa';
import Swal from 'sweetalert2';
import { getWebUserInfo, initializeWebUserInfo, setWebUserInfo } from '../utlilities/webConfig';
import '../App.css';
import { MdOutlineManageAccounts } from "react-icons/md";
import { MdOutlineAddShoppingCart } from "react-icons/md";
import { FaCartArrowDown } from "react-icons/fa";
import { FaShoppingBag } from "react-icons/fa";
import { SiMoleculer } from "react-icons/si";
import { HiDocumentReport } from "react-icons/hi";
import { HiOutlineUsers } from "react-icons/hi";
import { GrDocumentTest } from 'react-icons/gr';
import { BsDatabaseFillCheck } from "react-icons/bs";
import { MdOutlineVerifiedUser } from "react-icons/md";
import { IoReceiptOutline } from "react-icons/io5";
import { TabContext } from './TabbedLayout';
import axios from 'axios';
import { BASE_URL, GET_USER_MASTER, LOGIN, RESET_PASSWORD, applyPersistedBaseUrl } from '../utlilities/config';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Slide } from 'react-toastify';
import { MdOutlinePayments } from "react-icons/md";
import { FiCheckCircle } from "react-icons/fi";


const LeftMenu = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const tabContext = useContext(TabContext);
  const departmentName = typeof window !== 'undefined' ? window.localStorage.getItem('department_name') : '';
  const [collapsed, setCollapsed] = useState(true);
  const [activeMenuItem, setActiveMenuItem] = useState('');
  const [activeSubMenuItem, setActiveSubMenuItem] = useState('');
  const [toggled, setToggled] = useState(true);
  const [rtl] = useState(false);
  const [openSubmenu, setOpenSubmenu] = useState(null);
  const [permissions, setPermissions] = useState({});
  const [hoveredItem, setHoveredItem] = useState(null);
  const [userInfo, setUserInfo] = useState({});
  const [showSwitchAccountModal, setShowSwitchAccountModal] = useState(false);
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [password, setPassword] = useState('');
  const [loadingUsers, setLoadingUsers] = useState(false);
  const [switchingAccount, setSwitchingAccount] = useState(false);
  const [showPasswordChangeModal, setShowPasswordChangeModal] = useState(false);
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [changingPassword, setChangingPassword] = useState(false);
  const [appVersion, setAppVersion] = useState(process.env.REACT_APP_VERSION || '');


  const [firm, setFirm] = useState('');
  const [sysName, setSysName] = useState('');
  const [sysID, setSysID] = useState('');
  const [generalsettings, setGeneralSettings] = useState({});

  const isElectron = () => {
    return window && window.process && window.process.type;
  };

  let ipcRenderer;

  if (isElectron()) {
    ipcRenderer = window.require('electron').ipcRenderer;
  }

  const hidePaymentsMenu =
    String(generalsettings?.PhSeperateCollection || '').trim().toLowerCase() === 'yes';

  useEffect(() => {
    const loadAppVersion = async () => {
      if (isElectron() && ipcRenderer) {
        try {
          const version = await ipcRenderer.invoke('get-app-version');
          if (version) {
            setAppVersion(version);
          }
        } catch (error) {
          console.error('Error getting app version:', error);
        }
      }
    };

    loadAppVersion();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      let userRolesData;
      let userinfo;
      let generalSetting;
      if (isElectron()) {
        userRolesData = await ipcRenderer.invoke('store-get', 'user_role');
        userinfo = await ipcRenderer.invoke('store-get', 'userInfo');
        generalSetting = await ipcRenderer.invoke('store-get', 'generalopsettings');
        console.log(userinfo);
        setUserInfo(userinfo);
      } else {
        initializeWebUserInfo();
        userRolesData = getWebUserInfo().user_role; // Fetch from webConfig.js

        userinfo = getWebUserInfo().userInfo; // Fetch from webConfig
        generalSetting = getWebUserInfo().generalopsettings;
        setUserInfo(userinfo);
      }
      setGeneralSettings(generalSetting || {});
      setPermissions(processPermissions(userRolesData));
    };
    fetchData();
    getSystem();
  }, []);


  useEffect(() => {
    const path = location.pathname;

    if (path === '/salesentry') {
      setOpenSubmenu('');
      setActiveMenuItem('/salesentry');
      setActiveSubMenuItem('');
    } else if (path === '/salesreturn') {
      setOpenSubmenu('');
      setActiveMenuItem('/salesreturn');
      setActiveSubMenuItem('');
    } else if (path === '/opbilling') {
      setOpenSubmenu('');
      setActiveMenuItem('/opbilling');
      setActiveSubMenuItem('');
    } else if (path === '/purchaseentry') {
      setOpenSubmenu('purchase');
      setActiveMenuItem('/purchaseentry');
      setActiveSubMenuItem('');
    } else if (path === '/purchasereturn') {
      setOpenSubmenu('purchase');
      setActiveMenuItem('/purchasereturn');
      setActiveSubMenuItem('');
    } 
    else if (path === '/returnapproval') {
      setOpenSubmenu('purchase');
      setActiveMenuItem('/returnapproval');
      setActiveSubMenuItem('');
    } 
    else if (path === '/ipsalesentry') {
      setOpenSubmenu('ipsession');
      setActiveMenuItem('/ipsalesentry');
      setActiveSubMenuItem('');
    }
    else if (path === '/ipsalesreturn') {
      setOpenSubmenu('ipsession');
      setActiveMenuItem('/ipsalesreturn');
      setActiveSubMenuItem('');
    }
    else if (path === '/supplierpayment') {
      setOpenSubmenu('purchase');
      setActiveMenuItem('/supplierpayment');
      setActiveSubMenuItem('');
    }
    else if (path === '/openingstockentry') {
      setOpenSubmenu('utilities');
      setActiveMenuItem('/openingstockentry');
      setActiveSubMenuItem('');
    } else if (path === '/stockadjustment') {
      setOpenSubmenu('utilities');
      setActiveMenuItem('/stockadjustment');
      setActiveSubMenuItem('');
    } else if (path === '/stocktransfer') {
      setOpenSubmenu('utilities');
      setActiveMenuItem('/stocktransfer');
      setActiveSubMenuItem('');
    } else if (path === '/batchstock') {
      setOpenSubmenu('utilities');
      setActiveMenuItem('/batchstock');
      setActiveSubMenuItem('');
    } else if (path === '/expenseentry') {
      setOpenSubmenu('utilities');
      setActiveMenuItem('/expenseentry');
      setActiveSubMenuItem('');
    } else if (path === '/shortbooks') {
      setOpenSubmenu('utilities');
      setActiveMenuItem('/shortbooks');
      setActiveSubMenuItem('');
    } else if (path === '/productmaster') {
      setOpenSubmenu('masters');
      setActiveMenuItem('masters');
      setActiveSubMenuItem('productmaster');
    } else if (path === '/itemprivilegecard') {
      setOpenSubmenu('masters');
      setActiveMenuItem('masters');
      setActiveSubMenuItem('itemprivilegecard');
    } else if (path === '/patients') {
      setOpenSubmenu('masters');
      setActiveMenuItem('masters');
      setActiveSubMenuItem('patients');
    } else if (path === '/suppliermaster') {
      setOpenSubmenu('masters');
      setActiveMenuItem('masters');
      setActiveSubMenuItem('suppliermaster');
    } else if (path === '/payments') {
      setOpenSubmenu('');
      setActiveMenuItem('/payments');
      setActiveSubMenuItem('');
    } else if (path === '/chemicalmaster') {
      setOpenSubmenu('masters');
      setActiveMenuItem('masters');
      setActiveSubMenuItem('chemicalmaster');
    } else if (path === '/departmentmaster') {
      setOpenSubmenu('masters');
      setActiveMenuItem('masters');
      setActiveSubMenuItem('departmentmaster');
    } else if (path === '/usermaster') {
      setOpenSubmenu('masters');
      setActiveMenuItem('masters');
      setActiveSubMenuItem('usermaster');
    } else if (path === '/suppliermapping') {
      setOpenSubmenu('masters');
      setActiveMenuItem('masters');
      setActiveSubMenuItem('suppliermapping');
    } else if (path.startsWith('/reports')) {
      setOpenSubmenu('reports');
      setActiveMenuItem('reports');
      setActiveSubMenuItem(path);
    }
    else {
      setOpenSubmenu('');
      setActiveMenuItem(path);
      setActiveSubMenuItem('');
    }
  }, [location.pathname]);

  const processPermissions = (roles) => {
    const permissionsMap = {};
    roles.forEach((role) => {
      role.modules.forEach((module) => {
        permissionsMap[module.moduleName] = module.permissions;
      });
    });
    return permissionsMap;
  };

  const hasPermission = (moduleName, action) => {
    return permissions[moduleName]?.[action] || false;
  };

  useEffect(() => {
    setCollapsed(false);
    setToggled(false);
  }, [location.pathname]);

  const handleToggle = () => {
    setToggled(!toggled);
    setCollapsed(!collapsed);
  };

  const handleLogoutClick = () => {
    Swal.fire({
      title: 'Are you sure?',
      text: "Logout From the Application!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, Logout!'
    }).then((result) => {
      if (result.isConfirmed) {
        handleLogout();
      }
    });
  };

  const handleLogout = async () => {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('user_designation');
    localStorage.removeItem('department_id');
    localStorage.removeItem('series_name');
    localStorage.removeItem('department_name');
    localStorage.removeItem('finac_year');

    if (isElectron()) {
      const loginModeStored = await ipcRenderer.invoke('store-get', 'login_mode');

      await ipcRenderer.invoke('store-set', 'clientInfo', {});
      await ipcRenderer.invoke('store-set', 'sysInfo', {});
      await ipcRenderer.invoke('store-set', 'userInfo', {});
      await ipcRenderer.invoke('store-set', 'generalsettings', {});
      await ipcRenderer.invoke('store-set', 'user_role', {});
      await ipcRenderer.invoke('store-set', 'series_name', {});
      await ipcRenderer.invoke('store-set', 'generalopsettings', {});
      await ipcRenderer.invoke('store-set', 'finac_year', {});

      // Cloud: keep tenant auth, mobile, dashboard payload, selected client, api_base_url.
      // Re-apply main-process BASE_URL from store so it stays aligned with the chosen client.
      if (loginModeStored === 'cloud') {
        const origin = await ipcRenderer.invoke('store-get', 'api_base_url');
        if (origin && typeof origin === 'string') {
          await ipcRenderer.invoke('set-api-base-url', origin);
        }
      }
    }

    await applyPersistedBaseUrl();
    navigate('/');
  };

  const fetchUsers = async () => {
    setLoadingUsers(true);
    try {
      const token = localStorage.getItem('accessToken');
      const headers = {
        'XApiKey': process.env.REACT_APP_API_KEY,
      };
      if (token) {
        headers.Authorization = `Bearer ${token}`;
      }

      const response = await axios.get(`${BASE_URL}${GET_USER_MASTER}`, {
        headers
      });
      if (response.status === 200 && response.data?.isSucess) {
        setUsers(response.data?.data || []);
      }
    } catch (error) {
      console.error('Failed to fetch users:', error);
      toast.error('Could not load users', {
        autoClose: 1500,
      });
    } finally {
      setLoadingUsers(false);
    }
  };

  const handleSwitchAccountClick = () => {
    setShowSwitchAccountModal(true);
    setSelectedUser(null);
    setPassword('');
    fetchUsers();
  };

  const getSystem = async () => {
    if (isElectron()) {
      try {
        const systemname = await ipcRenderer.invoke('get-system');
        let deviceId = await ipcRenderer.invoke('get-device-id');

        const firm_namess = localStorage.getItem('firm_name');
        setFirm(firm_namess)

        // Check if the sysID contains braces and remove them if present
        if (deviceId.startsWith('{') && deviceId.endsWith('}')) {
          deviceId = deviceId.slice(1, -1); // Remove the first and last characters (the braces)
        }

        setSysID(deviceId);
        setSysName(systemname);

        return systemname;
      } catch (error) {
        console.error('Error fetching system name:', error);
        return null;
      }
    } else {
      // const systemname = 'Swalihs-MacBook-Air.local';
      // const deviceId = 'A8C8E98B-0259-531B-8574-9B7A4FE369CA';
      // setSysID(deviceId);
      // setSysName(systemname);
      // Cloud / browser: show selected tenant clientName
      try {
        const raw = localStorage.getItem('cloud_selected_client');
        const client = raw ? JSON.parse(raw) : null;
        setFirm(client?.clientName || '');
      } catch (_) {
        setFirm('');
      }
      const systemname = '';

      return systemname;
    }
  };


  const handlePasswordChangeClick = () => {
    setShowPasswordChangeModal(true);
    setCurrentPassword('');
    setNewPassword('');
    setConfirmPassword('');
  };

  const handlePasswordChange = async () => {
    // Validation
    if (!currentPassword || !newPassword || !confirmPassword) {
      toast.error('Please fill all fields', { autoClose: 1500 });
      return;
    }

    if (newPassword !== confirmPassword) {
      toast.error('New password and confirm password do not match', { autoClose: 1500 });
      return;
    }

    const payload = {
      currentPassword: currentPassword,
      newPassword: newPassword,
    };

    setChangingPassword(true);
    try {
      const token = localStorage.getItem('accessToken');

      const response = await axios.post(`${BASE_URL}${RESET_PASSWORD}`, payload, {
        headers: {
          'XApiKey': process.env.REACT_APP_API_KEY,
          'Authorization': `Bearer ${token}`,
        },
      });

      if (response.status === 200 && response.data?.isSucess) {
        toast.success('Password changed successfully', { autoClose: 1500 });
        setShowPasswordChangeModal(false);
        setCurrentPassword('');
        setNewPassword('');
        setConfirmPassword('');
        setChangingPassword(false);
        handleLogout();
      } else {
        // Handle case where status is 200 but isSucess is false
        const errorMessage = response.data?.message || 'Failed to change password';
        toast.error(errorMessage, { autoClose: 1500 });
        setChangingPassword(false);
      }
    } catch (error) {
      console.error('Failed to change password:', error);
      
      // Extract error message from response (handles 400, 401, etc.)
      const errorMessage =
        error.response?.data?.message ||
        error.response?.data?.Messages ||
        error.message ||
        'An error occurred while changing the password.';
      
      toast.error(errorMessage, { autoClose: 2000 });
      setChangingPassword(false);
    }
  };

  const handleAccountSwitch = async () => {
    if (!selectedUser || !password) {
      toast.error('Please select a user and enter password', {
        autoClose: 1500,
      });
      return;
    }

    try {
      const response = await axios.get(`${BASE_URL}${LOGIN}`, {
        headers: {
          'TenantName': 'ABC HEALTH CARE',
          'UserCode': selectedUser.UserCode,
          'Password': password,
          'XApiKey': process.env.REACT_APP_API_KEY,
          'sysID': sysID,
        },
      });
      
      if(response.status === 200) {

        const accessToken = response.data.data._accessToken;
        const refreshToken = response.data.data._refreshToken || {};
        const clientInfo = response.data.data.clientInfo[0] || {};
        const sysInfo = response.data.data.sysInfo[0] || {};
        const userInfo = response.data.data.userInfo[0] || {};
        const generalsettings = response.data.data.generalSettings[0] || {};

        const receptionSettingsString = response.data.data.generalSettings[0].ReceptionSettings || '[]';
        const receptionSettingsArray = JSON.parse(receptionSettingsString);

        const generalOpSettings = receptionSettingsArray[0] || {};
        
        const userRole = response.data.data._userRoles || {};

        const user_role = response.data.data._userRoles || {};
        const generalSettings = response.data.data.generalSettings[0] || {};

        const financial_year = clientInfo?.FicialYear
        const yearOnly = financial_year?.split('-')[0];

        console.log(yearOnly);

        // Save to localStorage
        localStorage.setItem('accessToken', accessToken);
        localStorage.setItem('refreshToken', refreshToken);
        localStorage.setItem('finac_year', yearOnly);

        if (isElectron()) {
          await ipcRenderer.invoke('store-set', 'clientInfo', clientInfo);
          await ipcRenderer.invoke('store-set', 'sysInfo', sysInfo);
          await ipcRenderer.invoke('store-set', 'userInfo', userInfo);
          await ipcRenderer.invoke('store-set', 'generalsettings', generalsettings);
          await ipcRenderer.invoke('store-set', 'user_role', userRole);
          await ipcRenderer.invoke('store-set', 'generalopsettings', generalOpSettings)
          await ipcRenderer.invoke('store-set', 'finac_year', yearOnly)
        } else {
          setWebUserInfo({ clientInfo, sysInfo, userInfo, generalSettings, user_role, generalOpSettings, yearOnly });
        }
        
        window.location.reload();
      } else {
        toast.error('Invalid Credentials', {
          autoClose: 1000,
        });
      }
    } catch (error) {
      console.error(error);
      toast.error(error.response?.data?.message || 'Login failed', {
        autoClose: 1000,
      });
    }
  };


  const getInitials = (name) => {
    if (!name) return 'U';
    const parts = name.trim().split(' ');
    if (parts.length >= 2) {
      return (parts[0][0] + parts[1][0]).toUpperCase();
    }
    return name.substring(0, 2).toUpperCase();
  };

  const handleMenuItemClick = async (itemId, path, submenuId, options = {}) => {
    if (submenuId) {
      setOpenSubmenu(submenuId);
      setActiveSubMenuItem(itemId);
    } else {
      setActiveMenuItem(itemId);
      setActiveSubMenuItem('');
      setOpenSubmenu('');
    }
    
    const shouldSkipPermission = userInfo?.Designation === 'Admin';

    // Check permissions and open tab or alert
    if (shouldSkipPermission || hasPermission(itemId, 'Create')) {
      // Remove leading slash from path if present
      const cleanPath = path.startsWith('/') ? path.substring(1) : path;
      
      // Use TabContext if available (single-window mode)
      if (tabContext && tabContext.openTab) {
        tabContext.openTab(cleanPath, itemId);
      } else {
        // Fallback to navigation for web
        navigate(path);
      }
    } else {
      Swal.fire({
        title: 'Access Denied',
        text: "You don't have permission to access this module.",
        icon: 'error',
        confirmButtonColor: '#3085d6',
      });
    }
  };

  // Custom styles for menu items
  const menuItemStyles = {
    root: {
      fontSize: '15px',
      fontWeight: '500',
    },
    button: {
      [`&.ps-active`]: {
        backgroundColor: 'rgba(99, 102, 241, 0.15)',
        color: '#4f46e5',
        fontWeight: '600',
        position: 'relative',
        '&::before': {
          content: '""',
          position: 'absolute',
          left: 0,
          top: 0,
          height: '100%',
          width: '4px',
          backgroundColor: '#4f46e5',
          borderRadius: '0 4px 4px 0',
        },
      },
      '&:hover': {
        backgroundColor: 'rgba(99, 102, 241, 0.08)',
        color: '#4f46e5',
      },
    },
    icon: {
      color: '#6b7280',
    },
    SubMenuExpandIcon: {
      color: '#6b7280',
    },
    subMenuContent: {
      backgroundColor: '#f8fafc',
      zIndex: 1000,
    },
    label: ({ open, active }) => ({
      fontWeight: open ? 600 : active ? 600 : 500,
    }),
  };

  return (
    <div className="h-full">
      <ToastContainer
        position="top-center"
        autoClose={1000}
        limit={1}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        transition={Slide}
      />
      <Sidebar
        className="h-full border-r border-gray-200 shadow-sm transition-all duration-300 ease-in-out"
        collapsed={collapsed}
        toggled={toggled}
        onBackdropClick={() => setToggled(false)}
        rtl={rtl}
        backgroundColor="white"
        rootStyles={{
          color: '#1e293b',
          zIndex: 100,
        }}
      >
        <div className="flex items-center justify-between px-4 py-4">
          <div className="flex items-center gap-2">
            <img 
              src={`${process.env.PUBLIC_URL}/logo.png`} 
              alt="FluxionLab Logo" 
              className="h-10 w-10 object-contain cursor-pointer" 
              onClick={handleToggle}
            />
            {!collapsed && (
              <div className="transition-opacity duration-300">
                <h2 className="text-xl font-bold text-blue-600">
                  FluxionPharmacy
                </h2>
                {(departmentName || appVersion) && (
                  <p className="flex items-center gap-2 text-xs font-medium text-black">
                    {departmentName && <span>{departmentName}</span>}
                  </p>
                )}
                <p className="flex items-center gap-2 text-xs font-medium text-black">
                  {isElectron()
                    ? localStorage.getItem('firm_name')
                    : firm}
                  {appVersion && <span className="text-black">v{appVersion}</span>}
                </p>
              </div>
            )}
          </div>
        </div>

        <div className="px-3">
          <div className="mb-2 mt-2 h-px bg-gray-200" />
        </div>

        <Menu 
          menuItemStyles={menuItemStyles}
          renderExpandIcon={({ open }) => (
            <span className="transition-transform duration-200 ease-in-out" style={{ transform: open ? 'rotate(90deg)' : '' }}>
              <IoChevronForwardOutline size={20} />
            </span>
          )}

          menuSectionStyles={{
            subMenuContent: {
              zIndex: 1000, // Ensure submenu content appears on top
            }
          }}

        >
          <MenuItem
            icon={<MdOutlineAddShoppingCart size={20} className="text-black" />}
            onClick={() => handleMenuItemClick('Sales Entry', '/salesentry')}
            active={location.pathname === '/salesentry'}
            className="transition-all duration-150 ease-in-out"
            onMouseEnter={() => setHoveredItem('salesentry')}
            onMouseLeave={() => setHoveredItem(null)}
          >
            <div className="flex items-center justify-between">
              <span>Sales Entry</span>
              {hoveredItem === 'salesentry' && !collapsed && (
                <span className="flex h-5 w-5 items-center justify-center rounded-full bg-indigo-100 text-xs text-indigo-600">
                  <IoChevronForwardOutline size={12} />
                </span>
              )}
            </div>
          </MenuItem>

          <MenuItem
            icon={<FaCartArrowDown size={20} className="text-black" />}
            onClick={() => handleMenuItemClick('Sales Return', '/salesreturn')}
            active={location.pathname === '/salesreturn'}
            className="transition-all duration-150 ease-in-out"
            onMouseEnter={() => setHoveredItem('salesreturn')}
            onMouseLeave={() => setHoveredItem(null)}
          >
            <div className="flex items-center justify-between">
              <span>Sales Return</span>
              {hoveredItem === 'salesreturn' && !collapsed && (
                <span className="flex h-5 w-5 items-center justify-center rounded-full bg-indigo-100 text-xs text-indigo-600">
                  <IoChevronForwardOutline size={12} />
                </span>
              )}
            </div>
          </MenuItem>

          <MenuItem
            icon={<IoReceiptOutline size={20} className="text-black" />}
            onClick={() => handleMenuItemClick('Pharmacy General Billing', '/opbilling')}
            active={location.pathname === '/opbilling'}
            className="transition-all duration-150 ease-in-out"
            onMouseEnter={() => setHoveredItem('opbilling')}
            onMouseLeave={() => setHoveredItem(null)}
          >
            <div className="flex items-center justify-between">
              <span>General Billing</span>
              {hoveredItem === 'opbilling' && !collapsed && (
                <span className="flex h-5 w-5 items-center justify-center rounded-full bg-indigo-100 text-xs text-indigo-600">
                  <IoChevronForwardOutline size={12} />
                </span>
              )}
            </div>
          </MenuItem>



          {!hidePaymentsMenu && (
            <MenuItem
              icon={<MdOutlinePayments size={20} className="text-black" />}
              onClick={() => handleMenuItemClick('Pharmacy Payment', '/payments')}
              active={location.pathname === '/payments'}
              className="transition-all duration-150 ease-in-out"
              onMouseEnter={() => setHoveredItem('payments')}
              onMouseLeave={() => setHoveredItem(null)}
            >
              <div className="flex items-center justify-between">
                <span>Payments</span>
                {hoveredItem === 'payments' && !collapsed && (
                  <span className="flex h-5 w-5 items-center justify-center rounded-full bg-indigo-100 text-xs text-indigo-600">
                    <IoChevronForwardOutline size={12} />
                  </span>
                )}
              </div>
            </MenuItem>
          )}


          <MenuItem
            icon={<FiUser size={20} className="text-black" />}
            onClick={() => handleMenuItemClick('Pharmacy Patient Master', '/patients')}
            active={location.pathname === '/patients'}
            className="transition-all duration-150 ease-in-out"
            onMouseEnter={() => setHoveredItem('patients')}
            onMouseLeave={() => setHoveredItem(null)}
          >
            <div className="flex items-center justify-between">
              <span>Patient Master</span>
              {hoveredItem === 'patients' && !collapsed && (
                <span className="flex h-5 w-5 items-center justify-center rounded-full bg-indigo-100 text-xs text-indigo-600">
                  <IoChevronForwardOutline size={12} />
                </span>
              )}
            </div>
          </MenuItem>


          <MenuItem
            icon={<FiCheckCircle size={20} className="text-black" />}
            onClick={() => handleMenuItemClick('DayClose', '/dayclose')}
            active={location.pathname === '/dayclose'}
            className="transition-all duration-150 ease-in-out"
            onMouseEnter={() => setHoveredItem('dayclose')}
            onMouseLeave={() => setHoveredItem(null)}
          >
            <div className="flex items-center justify-between">
              <span>Day Close</span>
              {hoveredItem === 'dayclose' && !collapsed && (
                <span className="flex h-5 w-5 items-center justify-center rounded-full bg-indigo-100 text-xs text-indigo-600">
                  <IoChevronForwardOutline size={12} />
                </span>
              )}
            </div>
          </MenuItem>


          <SubMenu
            icon={<HiDocumentReport size={20} className="text-black" />}
            label={
              <div className="flex items-center justify-between w-full">
                <span>Ip Session</span>
              </div>
            }
            open={openSubmenu === 'ipsession'}
            onClick={() => setOpenSubmenu(openSubmenu === 'ipsession' ? '' : 'ipsession')}
            className={openSubmenu === 'ipsession' ? "text-indigo-600 font-medium" : ""}
          >
            <div className="max-h-64 overflow-y-auto scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100">
              <MenuItem
                icon={<BsTruck size={20} className="text-black" />}
                onClick={() => handleMenuItemClick('Pharmacy Ip Billing', '/ipsalesentry', 'ipsession', { skipPermission: true })}
                active={location.pathname === '/ipsalesentry' && !location.search}
                className="pl-2"
              >
                Ip Billing
              </MenuItem>
              <MenuItem
                icon={<BsTruck size={20} className="text-black" />}
                onClick={() => handleMenuItemClick('Pharmacy Ip Sales Return', '/ipsalesreturn', 'ipsession', { skipPermission: true })}
                active={location.pathname === '/ipsalesreturn' && !location.search}
                className="pl-2"
              >
                Ip Sales Return
              </MenuItem>
            </div>
          </SubMenu>


          <SubMenu
            icon={<HiDocumentReport size={20} className="text-black" />}
            label={
              <div className="flex items-center justify-between w-full">
                <span>Purchase</span>
              </div>
            }
            open={openSubmenu === 'purchase'}
            onClick={() => setOpenSubmenu(openSubmenu === 'purchase' ? '' : 'purchase')}
            className={openSubmenu === 'purchase' ? "text-indigo-600 font-medium" : ""}
          >
            <div className="max-h-64 overflow-y-auto scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100">
              <MenuItem
                icon={<BsTruck size={20} className="text-black" />}
                onClick={() => handleMenuItemClick('Pharmacy Purchase Entry', '/purchaseentry', 'purchase', { skipPermission: true })}
                active={location.pathname === '/purchaseentry' && !location.search}
                className="pl-2"
              >
                Purchase Entry
              </MenuItem>
              <MenuItem
                icon={<FaShoppingBag size={20} className="text-black" />}
                onClick={() => handleMenuItemClick('Purchase Return', '/purchasereturn', 'purchase', { skipPermission: true })}
                active={location.pathname === '/purchasereturn' && !location.search}
                className="pl-2"
              >
                Purchase Return
              </MenuItem>
              <MenuItem
                icon={<MdOutlineVerifiedUser size={20} className="text-black" />}
                onClick={() => handleMenuItemClick('Return Approval', '/returnapproval', 'purchase', { skipPermission: true })}
                active={location.pathname === '/returnapproval' && !location.search}
                className="pl-2"
              >
                Return Approval
              </MenuItem>

              <MenuItem
                icon={<FiFileText size={20} className="text-black" />}
                onClick={() => handleMenuItemClick('Short Books', '/shortbooks', 'purchase', { skipPermission: true })}
                active={location.pathname === '/shortbooks' && !location.search}
                className="pl-2"
              >
                Short Books
              </MenuItem>
              <MenuItem
                icon={<MdOutlinePayments size={20} className="text-black" />}
                onClick={() => handleMenuItemClick('Pharmacy Supplier Payment', '/supplierpayment', 'purchase', { skipPermission: true })}
                active={location.pathname === '/supplierpayment' && !location.search}
                className="pl-2"
              >
                Supplier Payment
              </MenuItem>
            </div>
          </SubMenu>


          <SubMenu
            icon={<BsDatabaseFillCheck size={20} className="text-black" />}
            label={
              <div className="flex items-center justify-between w-full">
                <span>Utilities</span>
              </div>
            }
            open={openSubmenu === 'utilities'}
            onClick={() => setOpenSubmenu(openSubmenu === 'utilities' ? '' : 'utilities')}
            className={openSubmenu === 'utilities' ? "text-indigo-600 font-medium" : ""}
          >
            <div className="max-h-64 overflow-y-auto scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100">

              <MenuItem
                icon={<FiPackage size={20} className="text-black" />}
                onClick={() => handleMenuItemClick('Opening Stock', '/openingstockentry', 'utilities', { skipPermission: true })}
                active={location.pathname === '/openingstockentry' && !location.search}
                className="pl-2"
              >
                Opening Stock Entry
              </MenuItem>

              <MenuItem
                icon={<IoDocumentTextOutline size={20} className="text-black" />}
                onClick={() => handleMenuItemClick('Pharmacy Batch Stock', '/batchstock', 'utilities', { skipPermission: true })}
                active={location.pathname === '/batchstock' && !location.search}
                className="pl-2"
              >
                Batch Stock
              </MenuItem>


              <MenuItem
                icon={<FiEdit size={20} className="text-black" />}
                onClick={() => handleMenuItemClick('Stock Adjustment', '/stockadjustment', 'utilities', { skipPermission: true })}
                active={location.pathname === '/stockadjustment' && !location.search}
                className="pl-2"
              >
                Stock Adjustment
              </MenuItem>


              <MenuItem
                icon={<FiTruck size={20} className="text-black" />}
                onClick={() => handleMenuItemClick('Stock Transfer', '/stocktransfer', 'utilities', { skipPermission: true })}
                active={location.pathname === '/stocktransfer' && !location.search}
                className="pl-2"
              >
                Stock Transfer
              </MenuItem>

              <MenuItem
                icon={<FiCreditCard size={20} className="text-black" />}
                onClick={() => handleMenuItemClick('Expense Entry', '/expenseentry', 'utilities', { skipPermission: true })}
                active={location.pathname === '/expenseentry' && !location.search}
                className="pl-2"
              >
                Expense Entry
              </MenuItem>

            </div>
          </SubMenu>


          <div className="px-3">
            <div className="mb-2 mt-2 h-px bg-gray-200" />
            {!collapsed && <p className="mb-2 text-xs font-medium uppercase text-black">Analytics</p>}
          </div>


          <MenuItem
            icon={<HiDocumentReport size={20} className="text-black" />}
            onClick={() => handleMenuItemClick('Reports Hub', '/reports')}
            active={location.pathname === '/reports'}
            className="transition-all duration-150 ease-in-out"
            onMouseEnter={() => setHoveredItem('reports')}
            onMouseLeave={() => setHoveredItem(null)}
          >
            <div className="flex items-center justify-between">
              <span>Reports Hub</span>
              {hoveredItem === 'reports' && !collapsed && (
                <span className="flex h-5 w-5 items-center justify-center rounded-full bg-indigo-100 text-xs text-indigo-600">
                  <IoChevronForwardOutline size={12} />
                </span>
              )}
            </div>
          </MenuItem>

          <div className="px-3">
            <div className="mb-2 mt-2 h-px bg-gray-200" />
            {!collapsed && <p className="mb-2 text-xs font-medium uppercase text-black">Management</p>}
          </div>

          <SubMenu
            icon={<MdOutlineManageAccounts size={19} className="text-black" />}
            label={
              <div className="flex items-center justify-between w-full">
                <span>Masters</span>
              </div>
            }
            open={openSubmenu === 'masters'}
            onClick={() => setOpenSubmenu(openSubmenu === 'masters' ? '' : 'masters')}
            className={openSubmenu === 'masters' ? "text-indigo-600 font-medium" : ""}
          >
            <div className="max-h-64 overflow-y-auto scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100">
              <MenuItem
                icon={<GrDocumentTest size={20} className="text-black" />}
                onClick={() => handleMenuItemClick('Pharmacy Product Master', '/productmaster', 'masters')}
                active={location.pathname === '/productmaster'}
                className="pl-2"
              >
                Products
              </MenuItem>
              
              <MenuItem
                icon={<BsTruck size={20} className="text-black" />}
                onClick={() => handleMenuItemClick('Pharmacy Supplier Master', '/suppliermaster', 'masters')}
                active={location.pathname === '/suppliermaster'}
                className="pl-2"
              >
                Company/Supplier
              </MenuItem>

              <MenuItem
                icon={<SiMoleculer size={20} className="text-black" />}
                onClick={() => handleMenuItemClick('Pharmacy Chemical Master', '/chemicalmaster', 'masters')}
                active={location.pathname === '/chemicalmaster'}
                className="pl-2"
              >
                Chemical
              </MenuItem>

              <MenuItem
                icon={<FaBuilding size={20} className="text-black" />}
                onClick={() => handleMenuItemClick('Pharmacy Department Master', '/departmentmaster', 'masters')}
                active={location.pathname === '/departmentmaster'}
                className="pl-2"
              >
                Department
              </MenuItem>

              <MenuItem
                icon={<FiFileText size={20} className="text-black" />}
                onClick={() => handleMenuItemClick('Supplier Mapping', '/suppliermapping', 'masters')}
                active={location.pathname === '/suppliermapping'}
                className="pl-2"
              >
                Supplier Mapping
              </MenuItem>

              <MenuItem
                icon={<FiCreditCard size={20} className="text-black" />}
                onClick={() => handleMenuItemClick('Pharmacy Privilege Card', '/itemprivilegecard', 'masters')}
                active={location.pathname === '/itemprivilegecard'}
                className="pl-2"
              >
                Item Privilege Card
              </MenuItem>

            </div>
          </SubMenu>

          <MenuItem
            icon={<IoSettingsOutline size={20} className="text-black" />}
            onClick={() => handleMenuItemClick('Pharmacy Settings', '/settings')}
            active={location.pathname === '/settings'}
            className="transition-all duration-150 ease-in-out"
            onMouseEnter={() => setHoveredItem('settings')}
            onMouseLeave={() => setHoveredItem(null)}
          >
            <div className="flex items-center justify-between">
              <span>Settings</span>
              {hoveredItem === 'settings' && !collapsed && (
                <span className="flex h-5 w-5 items-center justify-center rounded-full bg-indigo-100 text-xs text-indigo-600">
                  <IoChevronForwardOutline size={12} />
                </span>
              )}
            </div>
          </MenuItem>

          <div className="mt-auto">
            <div className="px-3">
              <div className="mb-2 mt-4 h-px bg-gray-200" />
            </div>

            <MenuItem
              icon={
                <div className="flex h-8 w-8 items-center justify-center rounded-full bg-red-50 text-red-500">
                  <IoLogOutOutline size={19} />
                </div>
              }
              onClick={handleLogoutClick}
              className="mt-2 text-red-500 hover:text-red-600 hover:bg-red-50"
            >
              <span className="font-medium">Logout</span>
            </MenuItem>

            <MenuItem
              icon={
                <div className="flex h-8 w-8 items-center justify-center rounded-full bg-indigo-50 text-indigo-600 font-semibold text-sm">
                  {getInitials(userInfo?.UserName || 'User')}
                </div>
              }
              onClick={handleSwitchAccountClick}
              className="mt-2 text-indigo-600 hover:text-indigo-700 hover:bg-indigo-50"
            >
              <div className="flex flex-col leading-tight">
                <span className="font-medium">Switch Account</span>
                <span className="text-xs font-normal text-indigo-400 truncate max-w-[140px]">
                  {userInfo?.UserName || 'User'}
                </span>
              </div>
            </MenuItem>

            <MenuItem
              icon={
                <div className="flex h-8 w-8 items-center justify-center rounded-full bg-green-50 text-green-600">
                  <FiLock size={19} />
                </div>
              }
              onClick={handlePasswordChangeClick}
              className="mt-2 text-green-600 hover:text-green-700 hover:bg-green-50"
            >
              <span className="font-medium">Change Password</span>
            </MenuItem>
          </div>
        </Menu>
      </Sidebar>

      {/* Switch Account Modal */}
      {showSwitchAccountModal && (
        <div className="fixed inset-0 z-[200] flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md mx-4 transform transition-all">
            <div className="p-6">
              <div className="flex items-center justify-between mb-6">
                <h2 className="text-2xl font-bold text-gray-800">Switch Account</h2>
                <button
                  onClick={() => {
                    setShowSwitchAccountModal(false);
                    setSelectedUser(null);
                    setPassword('');
                  }}
                  className="text-gray-400 hover:text-gray-600 transition-colors"
                >
                  <FiX size={24} />
                </button>
              </div>

              {/* User Selection */}
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Select User
                </label>
                {loadingUsers ? (
                  <div className="flex items-center justify-center py-4">
                    <div className="animate-spin rounded-full h-6 w-6 border-t-2 border-b-2 border-indigo-600"></div>
                  </div>
                ) : (
                  <div className="max-h-48 overflow-y-auto border border-gray-200 rounded-lg">
                    {users
                      .filter((user) => user.UserID !== userInfo?.UserID)
                      .map((user) => (
                        <div
                          key={user.UserID}
                          onClick={() => setSelectedUser(user)}
                          className={`p-3 cursor-pointer border-b border-gray-100 last:border-b-0 transition-colors ${
                            selectedUser?.UserID === user.UserID
                              ? 'bg-indigo-50 border-indigo-200'
                              : 'hover:bg-gray-50'
                          }`}
                        >
                          <div className="flex items-center gap-3">
                            <div className="flex h-10 w-10 items-center justify-center rounded-full bg-indigo-100 text-indigo-600 font-semibold text-sm">
                              {getInitials(user.UserName)}
                            </div>
                            <div>
                              <div className="font-medium text-gray-800">{user.UserName}</div>
                              <div className="text-sm text-gray-500">{user.UserCode} - {user.Designation}</div>
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                )}
              </div>

              {/* Password Input */}
              <div className="mb-6">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Password
                </label>
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                    <FiLock className="text-gray-400" size={20} />
                  </div>
                  <input
                    type="password"
                    placeholder="Enter password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' && !switchingAccount) {
                        handleAccountSwitch();
                      }
                    }}
                    className="w-full pl-10 pr-4 py-3 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                    autoFocus
                  />
                </div>
              </div>

              {/* Action Buttons */}
              <div className="flex gap-3">
                <button
                  onClick={() => {
                    setShowSwitchAccountModal(false);
                    setSelectedUser(null);
                    setPassword('');
                  }}
                  className="flex-1 px-4 py-3 bg-gray-100 text-gray-700 rounded-lg font-medium hover:bg-gray-200 transition-colors"
                >
                  Cancel
                </button>
                <button
                  onClick={handleAccountSwitch}
                  disabled={!selectedUser || !password || switchingAccount}
                  className={`flex-1 px-4 py-3 bg-gradient-to-r from-indigo-600 to-purple-600 text-white rounded-lg font-medium hover:shadow-lg transition-all ${
                    (!selectedUser || !password || switchingAccount) ? 'opacity-50 cursor-not-allowed' : ''
                  }`}
                >
                  {switchingAccount ? (
                    <span className="flex items-center justify-center">
                      <div className="animate-spin rounded-full h-4 w-4 border-t-2 border-b-2 border-white mr-2"></div>
                      Switching...
                    </span>
                  ) : (
                    'Switch Account'
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Change Password Modal */}
      {showPasswordChangeModal && (
        <div className="fixed inset-0 z-[200] flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md mx-4 transform transition-all">
            <div className="p-6">
              <div className="flex items-center justify-between mb-6">
                <h2 className="text-2xl font-bold text-gray-800">Change Password</h2>
                <button
                  onClick={() => {
                    setShowPasswordChangeModal(false);
                    setCurrentPassword('');
                    setNewPassword('');
                    setConfirmPassword('');
                  }}
                  className="text-gray-400 hover:text-gray-600 transition-colors"
                >
                  <FiX size={24} />
                </button>
              </div>

              {/* Current Password Input */}
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Current Password <span className="text-red-500">*</span>
                </label>
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                    <FiLock className="text-gray-400" size={20} />
                  </div>
                  <input
                    type="password"
                    placeholder="Enter current password"
                    value={currentPassword}
                    onChange={(e) => setCurrentPassword(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' && !changingPassword) {
                        e.preventDefault();
                        document.getElementById('newPasswordInput')?.focus();
                      }
                    }}
                    className="w-full pl-10 pr-4 py-3 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                    autoFocus
                  />
                </div>
              </div>

              {/* New Password Input */}
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  New Password <span className="text-red-500">*</span>
                </label>
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                    <FiLock className="text-gray-400" size={20} />
                  </div>
                  <input
                    id="newPasswordInput"
                    type="password"
                    placeholder="Enter new password"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' && !changingPassword) {
                        e.preventDefault();
                        document.getElementById('confirmPasswordInput')?.focus();
                      }
                    }}
                    className="w-full pl-10 pr-4 py-3 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                  />
                </div>
                <p className="mt-1 text-xs text-gray-500">Must be at least 6 characters long</p>
              </div>

              {/* Confirm Password Input */}
              <div className="mb-6">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Confirm Password <span className="text-red-500">*</span>
                </label>
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                    <FiLock className="text-gray-400" size={20} />
                  </div>
                  <input
                    id="confirmPasswordInput"
                    type="password"
                    placeholder="Confirm new password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' && !changingPassword) {
                        e.preventDefault();
                        handlePasswordChange();
                      }
                    }}
                    className="w-full pl-10 pr-4 py-3 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                  />
                </div>
                {confirmPassword && newPassword !== confirmPassword && (
                  <p className="mt-1 text-xs text-red-500">Passwords do not match</p>
                )}
              </div>

              {/* Action Buttons */}
              <div className="flex gap-3">
                <button
                  onClick={() => {
                    setShowPasswordChangeModal(false);
                    setCurrentPassword('');
                    setNewPassword('');
                    setConfirmPassword('');
                  }}
                  className="flex-1 px-4 py-3 bg-gray-100 text-gray-700 rounded-lg font-medium hover:bg-gray-200 transition-colors"
                >
                  Cancel
                </button>
                <button
                  onClick={handlePasswordChange}
                  disabled={!currentPassword || !newPassword || !confirmPassword || newPassword !== confirmPassword || changingPassword}
                  className={`flex-1 px-4 py-3 bg-gradient-to-r from-indigo-600 to-purple-600 text-white rounded-lg font-medium hover:shadow-lg transition-all ${
                    (!currentPassword || !newPassword || !confirmPassword || newPassword !== confirmPassword || changingPassword) ? 'opacity-50 cursor-not-allowed' : ''
                  }`}
                >
                  {changingPassword ? (
                    <span className="flex items-center justify-center">
                      <div className="animate-spin rounded-full h-4 w-4 border-t-2 border-b-2 border-white mr-2"></div>
                      Changing...
                    </span>
                  ) : (
                    'Change Password'
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default LeftMenu;